import { f as r } from "./function-uncurry-this.js";
import { r as t } from "./require-object-coercible.js";
import { t as s } from "./to-string.js";
import { w as e } from "./whitespaces.js";
var i = r("".replace),
  o = RegExp("^[" + e + "]+"),
  n = RegExp("(^|[^" + e + "])[" + e + "]+$"),
  a = function a(r) {
    return function (e) {
      var a = s(t(e));
      return 1 & r && (a = i(a, o, "")), 2 & r && (a = i(a, n, "$1")), a;
    };
  },
  m = {
    start: a(1),
    end: a(2),
    trim: a(3)
  };
export { m as s };